import { render, staticRenderFns } from "./score-supplement.vue?vue&type=template&id=1d3063a9&"
import script from "./score-supplement.vue?vue&type=script&lang=js&"
export * from "./score-supplement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports